import React, { useState, useEffect } from 'react';
import './StarRatingModal.css';

const StarRatingModal = ({ 
  isOpen, 
  onClose, 
  onRate, 
  onRemoveRating,
  userEvaluation,
  bookTitle 
}) => {
  const [rating, setRating] = useState(0);
  const [hoveredRating, setHoveredRating] = useState(0);

  useEffect(() => {
    if (userEvaluation) {
      setRating(userEvaluation?.note);
    }
  }, [userEvaluation]);

  const handleRate = (value) => {
    setRating(value);
    onRate(value);
    onClose();
  };

  const handleRemoveRating = () => {
    setRating(0);
    onRemoveRating();
    onClose();
  };

  if (!isOpen) return null;

  const hasEvaluation = userEvaluation?.note > 0;

  return (
    <div className="star-rating-modal-overlay" onClick={onClose}>
      <div className="star-rating-modal" onClick={(e) => e.stopPropagation()}>
        <div className="star-rating-modal-header">
          <h3>{hasEvaluation ? 'Alterar avaliação' : 'Avalie esta obra'}</h3>
          <button className="star-rating-modal-close" onClick={onClose}>×</button>
        </div>
        
        <div className="star-rating-modal-content">
          <p className="star-rating-modal-book-title">{bookTitle}</p>
          
          <div className="star-rating-container">
            {[1, 2, 3, 4, 5].map((star) => (
              <button
                key={star}
                className={`star ${(hoveredRating || rating) >= star ? 'filled' : ''}`}
                onClick={() => handleRate(star)}
                onMouseEnter={() => setHoveredRating(star)}
                onMouseLeave={() => setHoveredRating(0)}
              >
                ★
              </button>
            ))}
          </div>
          
          <div className="star-rating-modal-actions">
            <button 
              className="star-rating-modal-btn remove"
              onClick={handleRemoveRating}
            >
              {hasEvaluation ? 'Remover avaliação' : 'Não quero avaliar'}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default StarRatingModal;